import { EventEmitter, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IOrgTreeSettings } from '@shared/interfaces/responsible/IOrgTreeSettings';
import { IResponsible } from '@shared/interfaces';
import { IOrganisationConfiguration } from '@shared/interfaces/responsible/IOrganisationConfiguration';
import { IListView } from '@shared/interfaces/various/IListView';
import { IQueryOrganisation } from '@shared/interfaces/queries/IQueryOrganisation';

@Injectable({
    providedIn: 'root'
})
export class OrgTreeService {
    reloadOrgTree = new EventEmitter<Array<string> | void>();
    isEditActive = new BehaviorSubject<boolean>(this.savedIsEditActive);
    toggleDrawer = new BehaviorSubject<{ isOpen: boolean; item?: IResponsible; isFirst?: boolean; force?: boolean }>({
        isOpen: false,
        isFirst: true,
        force: false
    });
    currentConfiguration: IOrganisationConfiguration;
    rootNode: IListView<IResponsible> & Partial<IResponsible>;
    activeQuery: IQueryOrganisation = {};

    constructor() {
        /* Constructor */
    }

    get orgTreeSettings(): IOrgTreeSettings {
        return JSON.parse(localStorage.getItem('orgTreeSettings')) ?? {};
    }

    set orgTreeSettings(val: IOrgTreeSettings) {
        localStorage.setItem('orgTreeSettings', JSON.stringify(val));
    }

    get savedIsEditActive(): boolean {
        return this.orgTreeSettings?.isEditActive;
    }

    set savedIsEditActive(val: boolean) {
        const settings = this.orgTreeSettings;
        settings.isEditActive = val;
        this.orgTreeSettings = settings;
    }

    reset() {
        this.toggleDrawer.next({
            isOpen: false,
            isFirst: true
        });
        this.currentConfiguration = null;
        this.rootNode = null;
        this.activeQuery = {};
    }
}
